/* ================================================================
   TUTBANANA B2B — LÓGICA FORMULARIO DE PEDIDO
   Archivo: assets/tutbanana-b2b.js
   ================================================================ */

(function () {
  'use strict';

  /* ---------- CONTROLES DE CANTIDAD ---------- */
  function initQtyControls() {
    document.querySelectorAll('.b2b-qty-control').forEach(function (ctrl) {
      var input = ctrl.querySelector('.b2b-qty-input');
      var minus = ctrl.querySelector('.b2b-qty-btn.minus');
      var plus  = ctrl.querySelector('.b2b-qty-btn.plus');
      if (!input) return;

      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 0;
        if (val > 0) { input.value = val - 1; triggerUpdate(input); }
      });
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 0;
        input.value = val + 1;
        triggerUpdate(input);
      });
      input.addEventListener('input', function () { triggerUpdate(input); });
    });
  }

  function triggerUpdate(input) {
    var event = new Event('b2b:qty-change', { bubbles: true });
    input.dispatchEvent(event);
  }

  /* ---------- RESUMEN DEL PEDIDO ---------- */
  function initOrderSummary() {
    var form = document.getElementById('b2b-order-form');
    if (!form) return;

    document.addEventListener('b2b:qty-change', updateSummary);
    updateSummary();
  }

  function updateSummary() {
    var rows     = document.querySelectorAll('.b2b-order-row[data-price]');
    var total    = 0;
    var items    = [];
    var itemsEl  = document.getElementById('b2b-summary-items');
    var totalEl  = document.getElementById('b2b-summary-total');
    var countEl  = document.getElementById('b2b-summary-count');
    var submitEl = document.getElementById('b2b-submit-btn');

    rows.forEach(function (row) {
      var qty   = parseInt(row.querySelector('.b2b-qty-input').value, 10) || 0;
      var price = parseFloat(row.dataset.price) || 0;
      var name  = row.dataset.title || '';
      var unit  = row.dataset.unit  || 'ud.';
      if (qty > 0) {
        var subtotal = qty * price;
        total += subtotal;
        items.push(qty + ' × ' + name + ' (' + unit + ') — ' + formatMoney(subtotal));
      }
    });

    if (itemsEl) {
      itemsEl.innerHTML = items.length
        ? items.map(function (i) { return '<div>' + i + '</div>'; }).join('')
        : '<span style="opacity:0.4">Sin productos seleccionados</span>';
    }
    if (totalEl) { totalEl.textContent = formatMoney(total) + '€'; }
    if (countEl) { countEl.textContent = items.length + ' producto' + (items.length !== 1 ? 's' : ''); }
    if (submitEl) { submitEl.disabled = items.length === 0; }
  }

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',');
  }

  /* ---------- CONSTRUCCIÓN DEL EMAIL ---------- */
  function initOrderForm() {
    var form = document.getElementById('b2b-order-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var rows    = document.querySelectorAll('.b2b-order-row[data-price]');
      var lines   = [];
      var total   = 0;
      var hasQty  = false;

      rows.forEach(function (row) {
        var qty     = parseInt(row.querySelector('.b2b-qty-input').value, 10) || 0;
        var price   = parseFloat(row.dataset.price) || 0;
        var name    = row.dataset.title || '';
        var unit    = row.dataset.unit  || '';
        var sku     = row.dataset.sku   || '';
        if (qty > 0) {
          hasQty = true;
          var subtotal = qty * price;
          total += subtotal;
          lines.push('  • ' + name + (sku ? ' [' + sku + ']' : '') + '\n    ' +
                     qty + ' ' + unit + ' × ' + formatMoney(price) + '€ = ' + formatMoney(subtotal) + '€');
        }
      });

      if (!hasQty) {
        e.preventDefault();
        alert('Añade al menos un producto antes de enviar el pedido.');
        return;
      }

      var empresa   = (document.getElementById('b2b-empresa')   || {}).value || '';
      var contacto  = (document.getElementById('b2b-contacto')  || {}).value || '';
      var telefono  = (document.getElementById('b2b-telefono')  || {}).value || '';
      var direccion = (document.getElementById('b2b-direccion') || {}).value || '';
      var fecha     = (document.getElementById('b2b-fecha')     || {}).value || 'Sin especificar';
      var notas     = (document.getElementById('b2b-notas')     || {}).value || '—';

      var body = [
        '═══════════════════════════════════',
        '  PEDIDO B2B — TUTBANANA',
        '═══════════════════════════════════',
        '',
        'DATOS DEL CLIENTE',
        '  Empresa:   ' + empresa,
        '  Contacto:  ' + contacto,
        '  Teléfono:  ' + telefono,
        '  Dirección: ' + direccion,
        '  Entrega:   ' + fecha,
        '',
        'PRODUCTOS SOLICITADOS',
        lines.join('\n'),
        '',
        '───────────────────────────────────',
        '  TOTAL ESTIMADO: ' + formatMoney(total) + '€',
        '  (Precio sujeto a confirmación)',
        '───────────────────────────────────',
        '',
        'OBSERVACIONES',
        '  ' + notas,
        '',
        '═══════════════════════════════════',
        'Pedido enviado desde Portal B2B',
        'tutbanana.es/pages/portal-b2b',
        '═══════════════════════════════════'
      ].join('\n');

      var bodyField = document.getElementById('b2b-contact-body');
      if (bodyField) { bodyField.value = body; }

      var subjectField = document.getElementById('b2b-contact-subject');
      if (subjectField) {
        subjectField.value = '🧾 PEDIDO B2B — ' + empresa.toUpperCase() + ' — ' + new Date().toLocaleDateString('es-ES');
      }
    });
  }

  /* ---------- FORMULARIO DE SOLICITUD DE ACCESO ---------- */
  function initRequestForm() {
    var form = document.getElementById('b2b-request-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      if (!email) { e.preventDefault(); alert('El email es obligatorio.'); }
    });
  }

  /* ---------- INIT ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initQtyControls();
    initOrderSummary();
    initOrderForm();
    initRequestForm();
  });

})();
